import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isAccessTokenValid } from "../utils/validateToken";
import { useSelector } from "react-redux";
import DashboardProfile from "../components/dashboard/DashboardProfile";
import "../styles/dashboard.css";

const Dashboard = () => {
	const { role } = useSelector((state) => state.auth);
	const accessToken = localStorage.getItem("accessToken");
	const isValidToken = isAccessTokenValid(accessToken);
	const navigate = useNavigate();

	useEffect(() => {
		if (!isValidToken && (role !== "user" || role !== "admin")) {
			navigate("/signin");
			// console.log(isValidToken)
			// console.log(role)
		}
	}, [isValidToken, role]);

	return (
		<div className="dashboard_content_wrapper">
			<DashboardProfile />
		</div>
	);
};

export default Dashboard;
